module.exports = __webpack_public_path__ + "static/img/3.443de0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p3/3.png
// module id = WISa
// module chunks = 1